
<template>
  <div>
    <ControlOption
      :campos="campos"
      :camposIndex="camposIndex">
      <!-- <v-checkbox
        v-model="checkbox"
        :label="campos.pregunta + (campos.obligatorio== 1 ? '  **' : '')"
        disabled >
      </v-checkbox> -->
      <v-alert
        class="my-3"
        dense
        dark
        color="accent">
        <strong> {{campos.pregunta}} </strong> 
      </v-alert>

    </ControlOption>

  </div>
</template>

<script>
import ControlOption from "@/components/dragdrop/Campos/ControlOption.vue";

export default {
  name:"Informacion",
  props: {
    campos: {
      type: Object,
      required: true
    },
    camposIndex: {
      type: Number,
      required: true
    },  
  },
  components: {
    ControlOption,
  },
  data() {
    return {
      label : true
    }
  },
    
}
</script>

<style lang="scss" scoped>

</style>
